import { useRef } from 'react'

import { getUniqueId } from '@surglogs/util'

export const useUniqId = ({ prefix = 'id' } = {}) => {
  const idRef = useRef(getUniqueId()) // probably we can also use here useConstant hook?!
  return `${prefix}-${idRef.current}`
}
